import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { LoadingSpinner } from '../../components/UI';
import { format } from 'date-fns';

export default function CitizenNotifications() {
  const [notifs, setNotifs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/notifications').then(r => setNotifs(r.notifications || [])).finally(() => setLoading(false));
  }, []);

  const typeIcon = { success: '✅', warning: '⚠️', error: '❌', info: 'ℹ️' };
  const typeColor = {
    success: 'border-green-200 bg-green-50',
    warning: 'border-yellow-200 bg-yellow-50',
    error: 'border-red-200 bg-red-50',
    info: 'border-blue-200 bg-blue-50',
  };

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-800 mb-6">🔔 Notifications</h1>
      {loading ? (
        <LoadingSpinner size="lg" className="py-20" />
      ) : notifs.length === 0 ? (
        <div className="text-center py-20 text-gray-400">
          <p className="text-5xl mb-3">🔔</p>
          <p>No notifications yet</p>
        </div>
      ) : (
        <div className="space-y-3">
          {notifs.map(n => (
            <div
              key={n.id}
              className={`p-4 border rounded-xl flex items-start gap-3 ${typeColor[n.type] || typeColor.info}`}
            >
              <span className="text-xl flex-shrink-0">{typeIcon[n.type] || 'ℹ️'}</span>
              <div className="flex-1">
                <p className="font-medium text-sm text-gray-800">{n.title}</p>
                <p className="text-sm text-gray-600 mt-0.5">{n.message}</p>
                <p className="text-xs text-gray-400 mt-1">
                  {format(new Date(n.created_at), 'dd MMM yyyy, hh:mm a')}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}